import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import Loading from "components/loading/loading";

function Component() {
  //
  // hooks

  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;
    instance.logoutRedirect().catch(console.error);
  }, [instance, inProgress]);

  // render

  return <Loading />;
}

export default Component;
